import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Scale, Shield, Truck, CreditCard, RotateCcw, Globe, Lock, FileText } from 'lucide-react';
import HomeHeader2 from '@/components/homePage/HomeHeader2';

const COLORS = {
  orange: "#E87E04",
  white: "#FFFFFF",
  green: "#008751",
  darkGreen: "#006B3F",
  lightOrange: "#FFE0B2",
  lightGreen: "#CCFFCC",
  gray: "#718096",
  lightGray: "#E2E8F0",
  paleGreen: "#E6FFEA",
};

const CGVPage = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Objet",
      icon: <FileText className="w-6 h-6" />,
      content: "Les présentes conditions visent à définir les relations contractuelles entre Kassarmou et l'Acheteur, ainsi que les conditions applicables à tout achat effectué par le biais du site kassarmoumarket.com. L'achat d'un produit via le présent site implique une acceptation sans réserve des présentes CGV, que l'Acheteur reconnaît avoir lues avant la commande."
    },
    {
      id: 2,
      title: "Produits",
      icon: <Globe className="w-6 h-6" />,
      content: "Les produits proposés sont ceux présentés sur le site kassarmoumarket.com, dans la limite des stocks disponibles. Ils incluent des produits alimentaires, accessoires, vêtements et articles artisanaux d'origine nigérienne. Chaque produit est présenté avec un descriptif détaillé. Les photos sont non contractuelles."
    },
    {
      id: 3,
      title: "Prix",
      icon: <CreditCard className="w-6 h-6" />,
      content: "Les prix sont indiqués en euros, toutes taxes comprises (TTC). Kassarmou se réserve le droit de modifier ses prix à tout moment. Les frais de livraison sont calculés lors de la commande selon le pays de destination. Ils sont à la charge de l'Acheteur sauf indication contraire."
    },
    {
      id: 4,
      title: "Commande et Paiement",
      icon: <CreditCard className="w-6 h-6" />,
      content: "Pour commander, l'Acheteur doit créer un compte ou commander en tant qu'invité. Le paiement s'effectue uniquement par carte bancaire via la plateforme sécurisée Stripe. La commande est confirmée après validation du paiement."
    },
    {
      id: 5,
      title: "Réserve de propriété",
      icon: <Shield className="w-6 h-6" />,
      content: "Kassarmou conserve la propriété des produits jusqu'au paiement intégral de la commande."
    },
    {
      id: 6,
      title: "Droit de rétractation",
      icon: <RotateCcw className="w-6 h-6" />,
      content: "Conformément à la législation, l'Acheteur dispose d'un délai de 14 jours ouvrables à compter de la livraison pour exercer son droit de rétractation, sauf pour les produits alimentaires et autres produits excluant le droit de retour pour des raisons d'hygiène ou de conservation."
    },
    {
      id: 7,
      title: "Livraison",
      icon: <Truck className="w-6 h-6" />,
      content: "La livraison est disponible pour la France, la Belgique, le Luxembourg, les Pays-Bas et l'Allemagne. Pour d'autres pays, l'Acheteur peut contacter Kassarmou via le formulaire de contact ou WhatsApp. La livraison est assurée par des partenaires sélectionnés. Les délais de livraison sont donnés à titre indicatif."
    },
    {
      id: 8,
      title: "Garantie",
      icon: <Shield className="w-6 h-6" />,
      content: "Tous les produits bénéficient de la garantie légale de conformité. En cas de défaut, l'Acheteur peut demander échange ou remboursement dans un délai de 30 jours."
    },
    {
      id: 9,
      title: "Responsabilité",
      icon: <Scale className="w-6 h-6" />,
      content: "Kassarmou ne saurait être tenue responsable des dommages liés à l'utilisation du réseau Internet (perte de données, intrusion, virus, etc.)."
    },
    {
      id: 10,
      title: "Propriété intellectuelle",
      icon: <Lock className="w-6 h-6" />,
      content: "Tous les éléments du site kassarmoumarket.com sont la propriété exclusive de Kassarmou. Toute reproduction, totale ou partielle, est interdite."
    },
    {
      id: 11,
      title: "Données personnelles",
      icon: <Lock className="w-6 h-6" />,
      content: "Kassarmou s'engage à respecter la confidentialité des données personnelles. Conformément au RGPD, l'Acheteur dispose d'un droit d'accès, de rectification et de suppression de ses données, à exercer par courrier ou via le formulaire de contact."
    },
    {
      id: 12,
      title: "Droit applicable",
      icon: <Scale className="w-6 h-6" />,
      content: "Les présentes CGV sont soumises au droit belge. En cas de litige, une solution amiable sera recherchée. À défaut, les tribunaux belges seront seuls compétents."
    }
  ];

  return (
    <>
    <HomeHeader2/>
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-green-50">
      {/* Header avec motif décoratif */}
      <div 
        className="relative overflow-hidden py-16 px-4"
        style={{ 
          background: `linear-gradient(135deg, ${COLORS.orange} 0%, ${COLORS.green} 100%)` 
        }}
      >
        {/* Motifs décoratifs */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-white"></div>
          <div className="absolute top-32 right-20 w-24 h-24 rounded-full bg-white"></div>
          <div className="absolute bottom-10 left-1/3 w-16 h-16 rounded-full bg-white"></div>
        </div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="mb-6">
            <Scale className="w-16 h-16 text-white mx-auto mb-4" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Conditions Générales de Vente
          </h1>
          <div className="w-24 h-1 bg-white mx-auto mb-6"></div>
          <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Kassarmou Market - Votre marketplace de produits authentiques du Niger
          </p>
          <div className="mt-8 text-white/80">
            <p>kassarmoumarket.com</p>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div 
          className="rounded-2xl p-8 mb-12 shadow-lg border-l-4"
          style={{ 
            backgroundColor: COLORS.paleGreen,
            borderLeftColor: COLORS.green 
          }}
        >
          <h2 className="text-2xl font-bold mb-4" style={{ color: COLORS.darkGreen }}>
            Préambule
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes conditions de vente sont conclues d'une part par l'entreprise individuelle 
            <strong> Kassarmou</strong>, dont le siège social est situé en Belgique, ci-après dénommée "Kassarmou", 
            gérant le site kassarmoumarket.com, et d'autre part, par toute personne physique ou 
            morale souhaitant procéder à un achat via le site internet kassarmoumarket.com, 
            dénommée ci-après "l'Acheteur".
          </p>
        </div>

        {/* Sections accordéon */}
        <div className="space-y-4">
          {sections.map((section) => (
            <div 
              key={section.id}
              className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleSection(section.id)}
                className="w-full px-6 py-5 flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex items-center space-x-4">
                  <div 
                    className="p-2 rounded-lg"
                    style={{ backgroundColor: COLORS.lightOrange }}
                  >
                    <div style={{ color: COLORS.orange }}>
                      {section.icon}
                    </div>
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Article {section.id}. {section.title}
                    </h3>
                  </div>
                </div>
                <div style={{ color: COLORS.orange }}>
                  {expandedSection === section.id ? (
                    <ChevronUp className="w-6 h-6" />
                  ) : (
                    <ChevronDown className="w-6 h-6" />
                  )}
                </div>
              </button>
              
              {expandedSection === section.id && (
                <div className="px-6 pb-6">
                  <div className="pl-14">
                    <div 
                      className="h-px mb-4"
                      style={{ backgroundColor: COLORS.lightGray }}
                    ></div>
                    <p className="text-gray-700 leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer de contact */}
        <div 
          className="mt-16 rounded-2xl p-8 text-center"
          style={{ 
            background: `linear-gradient(135deg, ${COLORS.lightGreen} 0%, ${COLORS.lightOrange} 100%)` 
          }}
        >
          <h3 className="text-2xl font-bold mb-4" style={{ color: COLORS.darkGreen }}>
            Besoin d'aide ?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Pour toute question concernant ces conditions générales de vente ou pour 
            exercer vos droits, n'hésitez pas à nous contacter.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/ContactPage"
              className="px-6 py-3 rounded-lg font-semibold text-white transition-all duration-300 hover:scale-105 shadow-md text-center"
              style={{ backgroundColor: COLORS.green }}
            >
              Formulaire de contact
            </a>
            <a 
              href="https://wa.me/32465965436"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-md border-2 text-center"
              style={{ 
                color: COLORS.orange,
                borderColor: COLORS.orange,
                backgroundColor: 'white'
              }}
            >
              WhatsApp
            </a>
          </div>
        </div>

        {/* Date de dernière mise à jour */}
        <div className="text-center mt-8 text-gray-500">
          <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
        </div>
      </div>
    </div>
    </>
  );
};

export default CGVPage;